/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseCountsDTO interface.
 */
export function instanceOfWarehouseCaseCountsDTO(value) {
    return true;
}
export function WarehouseCaseCountsDTOFromJSON(json) {
    return WarehouseCaseCountsDTOFromJSONTyped(json, false);
}
export function WarehouseCaseCountsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'awaitingSupport': json['awaitingSupport'] == null ? undefined : json['awaitingSupport'],
        'unread': json['unread'] == null ? undefined : json['unread'],
    };
}
export function WarehouseCaseCountsDTOToJSON(json) {
    return WarehouseCaseCountsDTOToJSONTyped(json, false);
}
export function WarehouseCaseCountsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'awaitingSupport': value['awaitingSupport'],
        'unread': value['unread'],
    };
}
